module.exports = __webpack_public_path__ + "static/media/Maax-Bold.fe5c0889.woff2";